export var WRONG_LIVECAM_CODE = "wrongCode";
export var VIDEO_STREAM_DATA = "videoStream";
export var SEND_LIVECAM_CODE = "videoCode";
export var HOST_STATE_CHANGE = "stateChange";